<template>
  <div class="layout">
    <slot v-if="$slots.header" name="header"></slot>
    <x-header v-else></x-header>
    <slot name="body"></slot>
    <slot v-if="$slots.footer" name="footer"></slot>
    <x-footer v-else></x-footer>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ELayout',
  components: {
  }
}
</script>
